import GHParam from './GHParam';

export default class GHOutputParam extends GHParam {
  constructor (name, nickName, instanceGuid) {
    super(name, nickName);

    this.instanceGuid = instanceGuid;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHOutputParam.js